import useMediaQuery from "./useMediaQuery";

export const useDeviceType = () => {
  const { isMobile, isTablet } = useMediaQuery();

  return isMobile ? "mobile" : isTablet ? "tablet" : "desktop";
};
